import {SERVER} from "../constants";
import {stringify} from "query-string";
import {MAP_URL} from "../constants/urls";
import {HttpClient} from "../utils/requests";
import {fixGetManyBlogCategories} from "../panels/blogCategory/blogCategoryMapper";
import {fixGetManyUsers} from "../panels/user/userMapper";
import {fixGetManyForumCategories} from "../panels/forumCategory/forumCategoryMapper";
import {fixGetManyReports} from "../panels/report/reportMapper";
import {fixGetManySpecialistCards} from "../panels/specialistCard/specialistCardMapper";
import {fixGetManySpecialistComments} from "../panels/specialistComment/specialistCommentMapper";
import {fixGetManyInvoices} from "../panels/invoice/invoiceMapper";
import {fixGetManyAdminLogHistories} from "../panels/adminLogHistory/adminLogHistoryMapper";
import {fixGetManyAdmins} from "../panels/adminUsers/adminUsersMapper";
import {fixGetManyAttachments} from "../panels/attachment/attachmentMapper";
import {fixGetManyConversations} from "../panels/conversation/conversationMapper";
import {fixGetManyMessages} from "../panels/message/messageMapper";
import {fixGetManySpecialistSalesReport} from "../panels/specialistSalesReport/specialistSalesReportMapper";
import {fixGetManySpecialistTransactions} from "../panels/specialistTransaction/specialistTransactionMapper";
import {fixGetManyAvatars} from "../panels/avatar/avatarMapper";
import {fixGetManyExperiments} from "../panels/experiment/experimentMapper";
import {fixGetManyUserVariants} from "../panels/userVariant/userVariantMapper";
import {fixGetManyVariants} from "../panels/variant/variantMapper";
import {fixGetManyPlanTypes} from "../panels/planType/planTypeMapper";
import {fixGetManyPlan} from "../panels/plan/planMapper";
import {fixGetManyBulkDiscounts} from "../panels/bulkDiscount/bulkDiacountMapper";

export function getMany(resource, params) {
  let ids = [];
  if (params.ids) {
    ids = params.ids;
  }
  const query = {
    filter: JSON.stringify({id: params.objectId, objectId: ids}),
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;
  return HttpClient(url).then(({json}) => {
    if (resource === "blogCategory") {
      return fixGetManyBlogCategories(json);
    } else if (resource === "user") {
      return fixGetManyUsers(json);
    } else if (resource === "forumCategory") {
      return fixGetManyForumCategories(json);
    } else if (resource === "report") {
      return fixGetManyReports(json);
    } else if (resource === "specialistCard") {
      return fixGetManySpecialistCards(json);
    } else if (resource === "specialistComment") {
      return fixGetManySpecialistComments(json);
    } else if (resource === "invoice") {
      return fixGetManyInvoices(json);
    } else if (resource === "adminLogHistory") {
      return fixGetManyAdminLogHistories(json);
    } else if (resource === "adminUsers") {
      return fixGetManyAdmins(json);
    } else if (resource === "attachment") {
      return fixGetManyAttachments(json);
    } else if (resource === "conversation") {
      return fixGetManyConversations(json);
    } else if (resource === "message") {
      return fixGetManyMessages(json);
    } else if (resource === "specialistSalesReport") {
      return fixGetManySpecialistSalesReport(json);
    } else if (resource === "specialistTransaction") {
      return fixGetManySpecialistTransactions(json);
    } else if (resource === "avatar") {
      return fixGetManyAvatars(json);
    } else if (resource === "variant") {
      return fixGetManyVariants(json);
    } else if (resource === "experiment") {
      return fixGetManyExperiments(json);
    } else if (resource === "userVariant") {
      return fixGetManyUserVariants(json);
    } else if (resource === "planType") {
      return fixGetManyPlanTypes(json);
    } else if (resource === "plan") {
      return fixGetManyPlan(json);
    } else if (resource === "bulkDiscount") {
      return fixGetManyBulkDiscounts(json);
    }

    return {
      data: {...json, id: json.objectId},
    };
  });
}
